import React from 'react';
import cx from 'classnames';

import Buttons from 'components/Buttons';
import Image from 'components/Image';
import MediaObject from 'components/MediaObject';
import Text from 'components/Text';
import CoachingAvatar from 'assets/images/coaching/coaching_avatar.svg';
import CoachingGetHelpButton from 'coaching/components/CoachingGetHelpButton';

import './styles/CoachingViewHeader.scss';

export type TextSize =
  | 'xxxxlarge'
  | 'xxxlarge'
  | 'xxlarge'
  | 'xlarge'
  | 'large'
  | 'medium'
  | 'small'
  | 'xsmall'
  | 'xxsmall'
  | 'xxxsmall'
  | 'xxxxsmall'
  | 'xxxxxsmall';

type Props = {
  title: string;
  isTabbed?: boolean;
  imageSize?: number;
  helpButtonEventKey?: string;
  textSize?: TextSize;
  isCoach?: boolean;
};

export default function CoachingViewHeader({
  isTabbed = false,
  imageSize = 40,
  textSize = 'large',
  title,
  helpButtonEventKey,
  isCoach,
}: Props) {
  return (
    <div className={cx('CoachingViewHeader', isTabbed && 'Tabbed')}>
      <MediaObject figure="right" className="CoachingViewHeader-top">
        <div className="CoachingViewHeader-left">
          <div className="CoachingViewHeader-left-group">
            <MediaObject center gutter="small">
              <Image width={imageSize} src={CoachingAvatar} />
              <div>
                <Text size={textSize} element="div" truncate weight="semibold">
                  {title}
                </Text>
              </div>
            </MediaObject>
          </div>
        </div>
        <div className="CoachingViewHeader-right">
          <Buttons>
            <CoachingGetHelpButton
              className="CoachingViewHeaderButtons--help"
              eventKey={helpButtonEventKey}
              isCoach={isCoach}
            />
          </Buttons>
        </div>
      </MediaObject>
    </div>
  );
}
